import * as React from 'react'

import { ActionItem, Box, Icon, Tag, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type EmployeeModel from 'modules/employees/store/models/Employee'
import AllowanceIncidenceModal from 'modules/timeoff/components/AllowanceIncidenceModal'
import { TargetBalance } from 'modules/timeoff/lib/enums'
import allowances from 'modules/timeoff/store/collections/allowances'
import type AllowanceIncidence from 'modules/timeoff/store/models/AllowanceIncidence'
import type { PolicyTimelineItem } from 'modules/timeoff/store/models/TimeoffPolicy/PolicyTimeline'

interface Props {
  allowanceIncidence: AllowanceIncidence
  employee: EmployeeModel
  canSetAllowanceIncidences: boolean
  timelineItem: PolicyTimelineItem
  hasManualAdjustmentOptions: boolean
}

const AllowanceIncidenceItem = ({
  allowanceIncidence,
  canSetAllowanceIncidences,
  employee,
  timelineItem,
  hasManualAdjustmentOptions,
}: Props) => {
  const [open, toggleModal] = useToggle(false)
  const amount = allowanceIncidence.units / 100
  const cycleRange = `${allowanceIncidence.cycleStart} - ${allowanceIncidence.cycleEnd}`
  const amountLabel = `${amount > 0 ? '+' : ''}${i18n.formatNumber(amount)} `

  const onClick = () => {
    if (!canSetAllowanceIncidences) return

    toggleModal(!open)()
  }
  const allowance = allowances.get(+allowanceIncidence.attributes.timeoff_allowance_id)

  const icon =
    allowance?.attributes.timeoff_policy_id === employee.attributes.timeoff_policy_id
      ? null
      : (highlighted: boolean) => (
          <Icon.Medium icon="alert" color={highlighted ? 'grey800' : 'grey600'} />
        )

  return (
    <ActionItem
      onClick={onClick}
      icon={icon}
      showIcon={canSetAllowanceIncidences}
      disabled={!canSetAllowanceIncidences}
      whiteDisabled
    >
      {open && (
        <AllowanceIncidenceModal
          incidence={allowanceIncidence}
          onClose={toggleModal(false)}
          employee={allowanceIncidence.employee}
          timelineItem={timelineItem as PolicyTimelineItem}
        />
      )}
      <Box gap="s4" justifyContent="spaceBetween" width="full">
        <Box width="s400">
          <Text size="200" weight="medium" color="grey1000" ellipsis>
            {allowanceIncidence.description}
          </Text>
        </Box>
        <Box flexDirection="row" gap="s4">
          <Text size="100" weight="semibold">
            {allowance?.attributes.name}
          </Text>
          <Text size="100">{cycleRange}</Text>
        </Box>
      </Box>
      <Box gap="s4" width="s140">
        <Text.Header2>
          {!amount ? '0 ' : amountLabel}
          <Text size="200" weight="medium" color="grey1000" inline>
            {allowanceIncidence.allowanceType}
          </Text>
        </Text.Header2>
        {hasManualAdjustmentOptions ? (
          <Tag inline type="grey">
            {allowanceIncidence.targetBalance == TargetBalance.Available
              ? i18n.t('time_off.incidences.available')
              : i18n.t('time_off.incidences.accrued')}
          </Tag>
        ) : (
          ''
        )}
      </Box>
    </ActionItem>
  )
}

export default observer(AllowanceIncidenceItem)
